import React from 'react'

import InvoiceForm from '../../components/invoices/form'
import {
  getDefaultGuestInvoiceValues,
  GuestPendingIntent,
} from '../../lib/guestInvoiceDraftStorage'

type Props = {
  onGuestSignInRequest?: (intent: GuestPendingIntent) => void
  guestSignInDismissNonce?: number
}

const GuestInvoiceSection = ({ onGuestSignInRequest, guestSignInDismissNonce }: Props) => (
  <section id='guest-invoice-form' className='container col-xxl-10 py-5 px-lg-5 rounded-3' aria-labelledby='guest-invoice-heading'>
    <InvoiceForm
      guestMode
      defaultValues={getDefaultGuestInvoiceValues()}
      onGuestSignInRequest={onGuestSignInRequest}
      guestSignInDismissNonce={guestSignInDismissNonce}
    />
  </section>
)

export default GuestInvoiceSection
